"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditTaskData = void 0;
var _react = require("react");
var _hooks = require("../../../../../hooks");
var _main = require("../../../../../main");
var _Button = require("../../../../../UI/Button");
var _Icon = require("../../../../../UI/Icon");
var _Menu = require("../../../../../UI/Menu");
var _http = require("../../../../../utilities/http");
var _urls = require("../../../../../utilities/urls");
var _useIframe = require("../../../hooks/useIframe");
var _TaskManager = require("../../../TaskManager.provider");
var _jsxRuntime = require("react/jsx-runtime");
const EditTaskData = props => {
  const {
    itemID,
    taskID,
    itemLanguage,
    kotarParams,
    minDate,
    maxDate,
    isLearningActivity
  } = props;
  const {
    isMobileView,
    task,
    setTask,
    unitData,
    setIsCloneItem,
    setIsCloneItemError,
    setEditTaskDataName,
    setEditTaskDataGuideLines,
    setIsEditTaskDataChanged,
    setIsEditTaskDataOpened,
    getLabel
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    isSessionDataReady,
    userId
  } = (0, _hooks.useSessionData)();
  const {
    setIframeData
  } = (0, _useIframe.useIframe)(itemID, itemLanguage, taskID, kotarParams, minDate, maxDate);
  const editItem = () => {
    if (isSessionDataReady && userId && unitData && task?.item) {
      const startStudio = (id, lang) => {
        setIframeData({
          src: unitData && unitData.taskFormUrls && unitData.taskFormUrls.studioUrl && unitData.taskFormUrls.studioUrl ? unitData.taskFormUrls.studioUrl.replace('http:', '').replace('{0}', id || '').replace('{1}', lang || '').replace('{2}', 'studioLO') : ''
        });
      };
      let toCopy = true;
      if (!task.item.isCet && task.item.ownerId === userId && !task.item.hasStarted) {
        toCopy = false;
      }
      if (toCopy) {
        setIsCloneItem(true);
        const id = task?.item && task.item.id || itemID;
        const lang = task?.item && task.item.cetLanguage || itemLanguage;
        _http.http.get(`${_urls.ofakimApiUrl}/lmscp/cloneItemToPersonalFolder?itemID=${id}&cetLanguage=${lang}`).then(_id => {
          if (_id && typeof _id === 'string') {
            setTask({
              ...task,
              item: {
                ...task.item,
                id: _id,
                isCet: false
              }
            });
            setIsCloneItemError(false);
            startStudio(_id, lang);
          } else {
            setIsCloneItemError(true);
          }
          setIsCloneItem(false);
        }).catch(error => {
          setIsCloneItemError(true);
          setIsCloneItem(false);
        });
      } else {
        startStudio(task.item.id, task.item.cetLanguage);
      }
    }
  };
  const openEditTaskDataForm = () => {
    setEditTaskDataName(task.name);
    setEditTaskDataGuideLines(task.guideLines);
    // if (taskApiTinymceRef && taskApiTinymceRef.current) {
    //   taskApiTinymceRef.current.setContent(task.guideLines);
    // }
    setIsEditTaskDataChanged(false);
    setIsEditTaskDataOpened(true);
  };
  const options = [{
    value: 'edit-data',
    label: getLabel('title_edit_Tooltip'),
    onClick: openEditTaskDataForm,
    isDisabled: !task || task.hasStarted || task.cannotModifyMembers || task.isReadOnly
  }, {
    value: 'edit-item',
    label: getLabel('open_studio_btn'),
    onClick: editItem,
    isDisabled: !task || task.hasStarted || task.cannotModifyMembers || task.isReadOnly
  }];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isMobileView || isLearningActivity ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      view: "contained",
      shape: "round",
      size: "medium",
      onClick: openEditTaskDataForm,
      category: isMobileView ? 'assignActivity' : undefined,
      label: isMobileView ? 'editActivity' : undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "Pen",
        width: "24",
        height: "24"
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Tooltip, {
      position: "top",
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
        options: options,
        isBoxCenteredToAnchor: true,
        btnProps: {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "Pen",
            width: "16",
            height: "16"
          }),
          view: 'contained',
          shape: 'round',
          size: 'small'
        }
      }),
      children: getLabel('open_studio_btn')
    })
  });
};
exports.EditTaskData = EditTaskData;